import React from 'react';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import GenericError from '../shared/Errors/GenericError';

export default function PinValidationError() {
    return (
        <Box
            sx={{
                backgroundColor: '#F4F5F6',
                inlineSize: 'unset',
                paddingTop: '80px',
                paddingBottom: '80px',
            }}
            id="max-attempts-pin-error-container"
            className="b-container-content">
            <GenericError title="Sorry, this PIN is no longer valid." id="max-attempts-pin">
                <Box sx={{ paddingBottom: '24px' }}>
                    You&apos;ve reached the maximum of 5 attempts. Here&apos;s what to do:
                </Box>
                <Box>
                    Ask your co-client to resend the invitation. Watch for another email with a new
                    link to try again.
                </Box>
            </GenericError>
        </Box>
    );
}
